import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store";
import "./assets/css/owl.carousel.min.css";
import "./assets/css/bootstrap.min.css";
import "./assets/css/style1.css";
import "./assets/css/style.css";
import "./assets/css/chat.css";
import "./assets/css/chatresponsive.css";
import "./assets/css/responsive.css";
import "bootstrap";
import 'vue3-carousel/dist/carousel.css';
import VueCookies from 'vue3-cookies';
import './registerServiceWorker'
import VueAwesomePaginate from "vue-awesome-paginate";
import globalProperties from './globalServices';


const app = createApp(App);
app.use(globalProperties);
app.use(router);
app.use(store);
app.use(VueCookies);
app.use(VueAwesomePaginate);
app.mount("#app");